import { motion } from "framer-motion";
import { ClipboardList, ShieldCheck, Rocket, HeartHandshake } from "lucide-react";

const steps = [
  {
    icon: ClipboardList,
    num: "01",
    title: "Requirements Analysis",
    desc: "We map your shipment volumes, routes, shift patterns and skill needs to define the exact manpower pool.",
    testid: "deployment-process-step-1",
  },
  {
    icon: ShieldCheck,
    num: "02",
    title: "Verification & Onboarding",
    desc: "Every candidate clears Aadhar, PAN and bank account verification plus route-knowledge and app-handling checks.",
    testid: "deployment-process-step-2",
  },
  {
    icon: Rocket,
    num: "03",
    title: "48-Hour Deployment",
    desc: "Dedicated pool deployed to your site within 48 hours — with 30–40% surge capacity for sale events.",
    testid: "deployment-process-step-3",
  },
  {
    icon: HeartHandshake,
    num: "04",
    title: "Payroll & Backup Managed",
    desc: "We run payroll, attendance and HR — and replace any absentee within 4 hours, guaranteed.",
    testid: "deployment-process-step-4",
  },
];

export const Process = () => (
  <section id="process" className="relative bg-[#111827] py-20 sm:py-28 border-y border-white/10 overflow-hidden">
    <div className="absolute inset-0 hero-grid-bg opacity-40 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14 max-w-2xl"
      >
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#3b82f6] mb-4">Deployment Workflow</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase text-slate-100 leading-[0.95]">
          From Brief to <span className="text-[#d4af37]">Boots on Ground</span>
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {steps.map((s, i) => (
          <motion.div
            key={s.testid}
            data-testid={s.testid}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.14, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="group relative bg-[#0d1424] border border-white/10 rounded-sm p-7 hover:border-[#d4af37]/40 transition-colors duration-500"
          >
            <div className="flex items-start justify-between mb-8">
              <s.icon className="w-7 h-7 text-[#3b82f6] group-hover:text-[#d4af37] transition-colors duration-500" />
              <span className="font-display text-5xl font-extrabold text-white/8 group-hover:text-[#d4af37]/20 transition-colors duration-500 leading-none">
                {s.num}
              </span>
            </div>
            <h3 className="font-display text-xl font-bold uppercase text-slate-100">{s.title}</h3>
            <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
            {i < steps.length - 1 && (
              <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-gradient-to-r from-[#d4af37]/60 to-transparent" />
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
